var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0375 30.125H31.0625C31.5802 30.125 32 30.5448 32 31.0625C32 31.5802 31.5802 32 31.0625 32H25.0375H23.5312H0.9375C0.41975 32 0 31.5802 0 31.0625C0 25.4808 3.53944 20.7107 8.49162 18.8776C5.24381 17.2309 3.01256 13.8588 3.01256 9.975C3.01256 4.47475 7.48731 0 12.9876 0C18.4878 0 22.9625 4.47475 22.9625 9.975C22.9625 11.9464 22.3875 13.7861 21.3966 15.3352C22.0788 15.1574 22.7941 15.0625 23.5312 15.0625C28.2009 15.0625 32 18.8616 32 23.5312C32 25.4324 30.4533 26.9791 28.5521 26.9791C27.5633 26.9791 26.671 26.5601 26.0417 25.8911C25.4124 26.5601 24.5201 26.9791 23.5312 26.9791C21.6301 26.9791 20.0834 25.4324 20.0834 23.5312C20.0834 21.6301 21.6301 20.0833 23.5312 20.0833C25.4325 20.0833 26.9792 21.6301 26.9792 23.5312C26.9792 24.3986 27.6848 25.1041 28.5521 25.1041C29.4194 25.1041 30.125 24.3986 30.125 23.5312C30.125 19.8954 27.1671 16.9375 23.5312 16.9375C19.8954 16.9375 16.9375 19.8954 16.9375 23.5312C16.9375 27.1671 19.8954 30.125 23.5312 30.125H25.0375ZM21.9584 23.5312C21.9584 24.3986 22.6639 25.1041 23.5312 25.1041C24.3986 25.1041 25.1043 24.3986 25.1043 23.5312C25.1043 22.6639 24.3986 21.9583 23.5312 21.9583C22.6639 21.9583 21.9584 22.6639 21.9584 23.5312ZM4.88756 9.975C4.88756 5.50863 8.52119 1.875 12.9876 1.875C17.4539 1.875 21.0876 5.50863 21.0876 9.975C21.0876 14.4414 17.4539 18.075 12.9876 18.075C8.52119 18.075 4.88756 14.4413 4.88756 9.975ZM12.9876 19.9499C7.17575 19.9499 2.39169 24.4344 1.91419 30.125H18.2235C16.2972 28.5714 15.0625 26.193 15.0625 23.5312C15.0625 22.3822 15.293 21.2861 15.7094 20.2861C14.8244 20.0632 13.9129 19.9499 12.9876 19.9499Z",
    fill: "#054089"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hover",
    cx: 13,
    cy: 10,
    r: 10,
    fill: "#054089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hover",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37988 30.5H18.7114C18.7114 30.5 13.0155 25.4579 16.5143 19.95C4.44048 17.7498 1.37988 30.5 1.37988 30.5Z",
    fill: "#054089"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a411b610.svg";
export { ForwardRef as ReactComponent };